/**
 * El botón de claro y oscuro · 24-09-2026
 *
 * Va en la cabecera del panel del club y en la del back office. Enseña **a lo que
 * se pasa**, no lo que hay: la luna en claro, el sol en oscuro, que es lo que hacen
 * los sistemas operativos y lo que se espera al buscarlo. El texto accesible dice
 * lo mismo con palabras.
 */
import { elegirAspecto, useAspecto } from '@/shared/ui/aspecto';

export function CambiarAspecto() {
  const aspecto = useAspecto();
  const destino = aspecto === 'oscuro' ? 'claro' : 'oscuro';
  const texto = `Pasar a modo ${destino}`;

  return (
    <button
      type="button"
      className="btn-plano btn-icono"
      aria-label={texto}
      title={texto}
      onClick={() => elegirAspecto(destino)}
    >
      {destino === 'oscuro' ? <Luna /> : <Sol />}
    </button>
  );
}

function Luna() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
      <path
        d="M20.5 14.3A8.5 8.5 0 0 1 9.7 3.5a8.5 8.5 0 1 0 10.8 10.8Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function Sol() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      >
        <circle cx="12" cy="12" r="4" />
        <path d="M12 2.5v2M12 19.5v2M2.5 12h2M19.5 12h2M5.3 5.3l1.4 1.4M17.3 17.3l1.4 1.4M5.3 18.7l1.4-1.4M17.3 6.7l1.4-1.4" />
      </g>
    </svg>
  );
}
